import { useLanguage } from "@/i18n";

export const Marquee = () => {
  const { t } = useLanguage();
  return (
    <div className="overflow-hidden bg-brand-900 py-4" data-testid="partners-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {t.marquee.map((item, idx) => (
              <span key={idx} className="flex items-center whitespace-nowrap">
                <span className="mx-7 font-mono text-sm font-medium uppercase tracking-[0.3em] text-white/90">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-brand-400" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
